import './App.css';
import Configurator from './Configurator';

function App() {
  return (
    <div className="App">
      <Configurator />
    </div>
  );
}

export default App;
